import React, { useEffect, useState } from 'react';
import { useIsMutating, useIsFetching } from '@tanstack/react-query';
import { cn } from '@/lib/utils';

export const GlobalProgressBar: React.FC = () => {
  const isMutating = useIsMutating();
  const isFetching = useIsFetching();
  const [progress, setProgress] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  const isLoading = isMutating > 0 || isFetching > 0;

  useEffect(() => {
    let interval: NodeJS.Timeout | null = null;

    if (isLoading) {
      setIsVisible(true);
      setProgress(0);
      
      // Indeterminate progress animation
      interval = setInterval(() => {
        setProgress(prev => {
          if (prev >= 90) return 90; // Cap at 90% until actually complete
          return prev + Math.random() * 10;
        });
      }, 300);
    } else if (isVisible) {
      // Complete the animation
      setProgress(100);
      
      // Hide after completion animation
      setTimeout(() => {
        setIsVisible(false);
        setProgress(0);
      }, 400);
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [isLoading, isVisible]);

  if (!isVisible) return null;

  return (
    <div 
      className={cn(
        "fixed top-0 left-0 right-0 z-[100] h-1 overflow-hidden transition-opacity duration-300",
        progress === 100 ? "opacity-0" : "opacity-100"
      )}
    >
      <div 
        className="h-full bg-primary transition-all duration-300 ease-out"
        style={{ 
          width: `${progress}%`,
          boxShadow: '0 0 10px hsl(var(--primary))'
        }}
      />
    </div>
  );
};
